import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { apiColletions } from 'src/app/core/constant/api-collection';
import { ApiService } from './api.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { Helper } from 'src/app/shared/helper';

@Injectable({
    providedIn: 'root',
})
export class UserService {
    private _userTokenUpdate = new BehaviorSubject<any>(null);
    _userTokenObservable = this._userTokenUpdate.asObservable();
    private _userDataUpdate = new BehaviorSubject<any>(null);
    _userdataObservable = this._userDataUpdate.asObservable();
    private _settingsUpdate = new BehaviorSubject<any>(null);
    _settingsObservable = this._settingsUpdate.asObservable();

    constructor(
        private _api: ApiService,
        private helper: Helper,
        private _http: HttpClient
    ) { }

    async get_settings(): Promise<boolean> {
        try {
            const response = await this._api.get({ url: apiColletions.user_settings })
            this._settingsUpdate.next({ data: response});
            return false;
        } catch (err) {
            return false;
        }
    }

    async user_login(parameters: any): Promise<boolean> {
        try {
            const response = await this._api.post({ url: apiColletions.user_login, parameters })
            this.helper.jwt_token = response;
            localStorage.setItem('login_token', "response");
            this._userTokenUpdate.next({ token: response });
            this.get_user_profile();
            return false;
        } catch (err) {
            return false;
        }
    }

    async user_register(parameters: any): Promise<boolean> {
        try {
            const response = await this._api.post({ url: apiColletions.user_register, parameters })
            return false;
        } catch (err) {
            return false;
        }
    }

    async get_user_profile(): Promise<boolean> {
        try {
            const response = await this._api.get({ url: apiColletions.get_user_profile })
            // this.helper.userDetails = JSON.stringify(response.data);
            // localStorage.setItem('loginData', JSON.stringify(response.data));
            // this._userDataUpdate.next(response.data);
            return false;
        } catch (err) {
            return false;
        }
    }

    async update_user_profile(parameters: any): Promise<boolean> {
        try {
            const response = await this._api.put({ url: apiColletions.get_user_profile, parameters })
            return false;
        } catch (err) {
            return false;
        }
    }

    async forgot_password_with_email(parameters: any): Promise<boolean> {
        try {
            const response = await this._api.post({ url: apiColletions.forgot_password_by_email, parameters })
            return false;
        } catch (err) {
            return false;
        }
    }

    async reset_password_with_email(parameters: any): Promise<boolean> {
        try {
            const response = await this._api.post({ url: apiColletions.reset_password_by_email, parameters })
            return false;
        } catch (err) {
            return false;
        }
    }

    getUserDetail(parameters: any): Observable<boolean> {
        return new Observable<boolean>((observer) => {
            this._api.get({ url: apiColletions.userDetail, parameters }).subscribe({
                next: (response) => {
                    if (response.data) {
                        const userDetail = response?.data?.data;
                        this.helper.userDetails = userDetail;
                        this._userDataUpdate.next(userDetail);
                        localStorage.setItem('loginData', JSON.stringify(userDetail));
                        observer.next(response.data);
                        observer.complete();
                    } else {
                        observer.next(false);
                        observer.complete();
                    }
                },
                error: () => {
                    observer.next(false);
                    observer.complete();
                }
            });
        });
    }

    updateEntityDetial(entityId: string, parameters: any, entityType: number): Observable<boolean> {
        return new Observable<boolean>((observer) => {
            const url = `${apiColletions.updateEntityDetail}?id=${entityId}&type=${entityType}`;
            this._api.put({ url: url, parameters }).subscribe({
                next: (response) => {
                    if (response.data) {
                        this.helper.userDetails = parameters;
                        this._userDataUpdate.next(parameters);
                        observer.next(response.data);
                        observer.complete();
                    } else {
                        observer.next(false);
                        observer.complete();
                    }
                },
                error: () => {
                    observer.next(false);
                    observer.complete();
                }
            });
        });
    }
}
